// extracted by mini-css-extract-plugin
export default {"list":"SwapConfirm_list__r6DUm","item":"SwapConfirm_item__sLu1O","article":"SwapConfirm_article__0kQ7H","title":"SwapConfirm_title__68hCN","content":"SwapConfirm_content__SyATT"};